import { Pipe, PipeTransform } from '@angular/core';
import { Event, EventLocation } from '../../../pages/overview/models/shipment';

interface EventDetails {
  timeLocal: string;
  timeUtc: string;
  containerNo: string | null;
}

interface FilteredEvent {
  location: EventLocation;
  name: string | null;
  details: EventDetails[];
}

@Pipe({
  name: 'filterOutEvents',
  standalone: true
})
export class FilterOutMilestonesPipe implements PipeTransform {
  transform(events: Event[] | null): FilteredEvent[] {
    const filteredEvents: FilteredEvent[] = [];
    if (!events || events.length === 0) {
      return filteredEvents;
    }
    events.forEach(event => {
      const equalEvents = this.areSameEvents(filteredEvents, event);
      if (equalEvents) {
        if (!this.haveSameTimeAndContainerNumber(equalEvents, event)) {
          equalEvents.details.push({
            timeUtc: event.timeUtc,
            timeLocal: event.timeLocal,
            containerNo: event.containerNo
          });
        }
      } else {
        filteredEvents.push({
          location: event.location,
          name: event.name,
          details: [{ timeUtc: event.timeUtc, timeLocal: event.timeLocal, containerNo: event.containerNo }]
        });
      }
    });

    return this.sorted(filteredEvents);
  }

  private areSameEvents(filteredEvent: FilteredEvent[], event: Event) {
    return filteredEvent.find(
      ({ location, name }) =>
        location.code === event.location.code &&
        location.countryCode === event.location.countryCode &&
        name === event.name
    );
  }

  private haveSameTimeAndContainerNumber(filteredEvent: FilteredEvent, event: Event) {
    return filteredEvent.details.find(
      ({ timeUtc, containerNo }) => timeUtc === event.timeUtc && containerNo === event.containerNo
    );
  }

  private sorted(toBeSorted: FilteredEvent[]) {
    const sorted = [...toBeSorted];
    sorted.forEach(event =>
      event.details.sort(
        (a: EventDetails, b: EventDetails) => new Date(a.timeUtc).getTime() - new Date(b.timeUtc!).getTime()
      )
    );
    return sorted.sort(
      (a: FilteredEvent, b: FilteredEvent) =>
        new Date(a.details[0].timeUtc).getTime() - new Date(b.details[0].timeUtc).getTime()
    );
  }
}
